import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm, Switch } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeBodyShape, updateSts, modifyBodyShapeDisabled } from './BodyShapeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import "./bodyShapeCss.css";

export default function BodyShapeList() {
  const [isDisabled, setIsDisabled] = useState<any>();
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodyShape, list_data, setList } = React.useContext(CommonContext) as CommonContextType;
  const BodyShape = useSelector(
    (state: AppState) => state.BodyShape
  );
  useEffect(() => {
    setList(BodyShape.BodyShapeArr)
  }, [BodyShape]);


  useEffect(() => {
    if (BodyShape.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: BodyShape.success.data,
      });

      dispatch(updateSts({}));
    } else if (BodyShape.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: BodyShape.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [BodyShape])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodyShape(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeBodyShape(id));
   /*  messageApi.open({
      type: 'success',
      content: 'Body Shape deleted successfully',
    }); */
  };

  const onToggleChange = (id: any, checked: boolean) => {
    checked = !checked
    setIsDisabled(checked)
    const formData = {
      disabled: checked
    }
    dispatch(modifyBodyShapeDisabled(formData, id))
    /* messageApi.open({
      type: 'success',
      content: 'Category updated successfully',
    }); */

  };


  

  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={list_data}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div className='first_class'>
            <img width={70} alt="shape" src={process.env.REACT_APP_AZURE_BLOB_STORAGE_API + item.shape_img_url} />
            <div className='sub_data' style={{ width: '60%', marginLeft: '50px' }}><b>ID:</b> {index + 1} <br /><b>Order:</b> {item?.order} <br /><b>Name:</b> {item.shape_name} <br /><b>Code:</b> {item.shape_code} <br /><b>Category:</b> {item?.cat?.category_name} <br /><b>Nut Qty:</b> {item.nut_qty}<br /><b>Product Type:</b> {(item?.product_type?.type_name) ? item?.product_type?.type_name : 'NA'}<br />
            {item?.cat?.category_code == 'PUMP' ?
            <div><b>Body Size: </b>{item?.body_size}</div>
             : null}

            </div>

            <Popconfirm title="Sure to update status?" onConfirm={() => onToggleChange(item.id, item.disabled)}>
              <Switch style={{ backgroundColor: item?.disabled ? '#bfbfbf' : '#1577ff' }} checked={item?.disabled} checkedChildren="Disabled" unCheckedChildren="Enabled" />
            </Popconfirm>
          </div>
        </List.Item>
      )}
    />
  );
}